// extracted by mini-css-extract-plugin
module.exports = {"root":"Header_root__2Pmpq","paddingBottom":"Header_paddingBottom__13XkG","desktop":"Header_desktop__2j0ls","wrapper":"Header_wrapper__1IKOJ","switcher":"Header_switcher__3bImS"};